






  
  <div  class="reference_body">
    <div class="pink_box"></div>
    <div class="green_box"></div>
       <div class="input_card section">
          <div class="main_info">
            <div class="container">
              <div class="top_split">
                  <div>
                    <div class="message" *ngIf="(isReady$ | async) || (hasFailed$ | async)">
                      <input #file type="file"  class="top prmiary_button" multiple (change)="uploadFile($event)" />
                    </div>
                   
                   
                  </div>
               
                  <div>

                    <div class="row top_search sticky-nav" style="width: 95%">
     
                      <div class="col-md-8">
                
                
                       <input class="stakeholder_search"
                                     type="text"
                                     
                                     placeholder="Search for Documents" [(ngModel)]="searchvalue" (ngModelChange)="searchDocuments()"
                                 />
                
                 
                     
                      </div>
                      <div class="col-md-4" >
                        <button class="top prmiary_button" style="margin-top: 15px; box-shadow: none;" (click)="addWithoutFile()"  >
                          Add <em class="ti-plane"></em>
                        </button>
                        <button class="top prmiary_button" style="margin-top: 15px; box-shadow: none;" (click)="OnSubmit()"  >
                          Submit <em class="ti-plane"></em>
                        </button>
                      </div>
                 </div>
                  
                   
                   
                  </div>
              </div>

              <div class="message" *ngIf="(isInProgress$ | async)">
                <div style="margin-bottom: 14px;">Uploading... {{ progress$ | async }}%</div>
              </div>
              
              <div class="message" *ngIf="(isInProgress$ | async)">
                <button (click)="cancelUpload()">Cancel Upload</button>
              </div>
              
              <div class="message" *ngIf="(completed$ | async)">
                <h4>
                  File has been uploaded successfully!
                </h4>
                <button (click)="resetUpload()">Upload Another File</button>
              </div>
              
              <div class="message error" *ngIf="(hasFailed$ | async)">
                Error: {{ error$ | async }}
              </div>

              <div class="row input_card" *ngIf="selectedFileName.length > 0">
                   <div class="col-md-6">
                    <div class="filechange">
                      <mat-icon style="color: orange">supervisor_account</mat-icon> {{selectedFileName}}
                    </div>
                   </div>
                   <div class="col-md-4">
                    <mat-icon style="color: orange">supervisor_account</mat-icon> {{fileSize}}
                  </div>
                  <div class="col-md-2">
                    <mat-icon style="color: orange">supervisor_account</mat-icon> {{fileType}}
                  </div>
              </div>
        </div>
    
          </div>
       </div>


      




    <div class="input_card section">


      <!-- <div style="background-color: hotpink; height: 40px;">
         {{OriginatedModuleSpecificId}}
      </div> -->

      <form [formGroup]="documentForm"  *ngIf="showDocDescForm"  >
      <div class="main_info">
    
        <div class="row">
          <div class="col-md-6">
            <div class="input_card">
              <label for="">Title</label>
              <input type="text" name="" id="" cols="130"  class="description" 
                  placeholder="Enter description" formControlName="DocumentTitle"/>
            </div>
          </div>
      
          <div class="col-md-6">
            <div class="input_card" style="width: 90%;">
              <label for="">File Name</label>
              <input type="text" name="" id="" cols="130"  class="description" 
                  placeholder="Ref No" formControlName="FileName"/>
            </div>
          </div>
          
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="input_card">
              <label for="">Description</label>
              <textarea name="" id="" cols="130" rows="3" class="description" 
                  placeholder="Enter description" formControlName="DocumentDescription"></textarea>
            </div>
          </div>
          
        </div>
      
        <div class="row">
          <div class="col-md-6">
            <div class="input_card">
              <label for="">URL</label>
              <textarea name="" id="" cols="130" rows="3" class="description" 
                  placeholder="Enter description" formControlName="DocumentURL" (mouseleave)="doesFileExistwithURL()"></textarea>
            </div>
            <div class="alert alert-danger" *ngIf="!fileExist">
                 {{fileExistMsg}}
            </div>
          </div>
      
          <div class="col-md-6">
            <div class="input_card" style="width: 90%;">
              <label for="">Other</label>
              <textarea name="" id="" cols="130" rows="3" class="description" 
                  placeholder="Enter " ></textarea>
            </div>
          </div>
          
        </div>


        <div class="row">
          <div class="col-md-12">
            <mat-accordion>
              <mat-expansion-panel class="section" >
                <mat-expansion-panel-header style="margin-bottom: 5px;">
                  <mat-panel-title style="padding:3rem 0;">
                    <mat-icon style="color: orange">supervisor_account</mat-icon> Categorise
                  </mat-panel-title>
                  <mat-panel-description>
                   
                  </mat-panel-description>
                </mat-expansion-panel-header>
    
                <div class="row">
                  <div class="col-md-3">
                    <mat-form-field>
                      <mat-label>Document Type</mat-label>
                      <mat-select formControlName="DocumentTypeId">
                        <mat-option *ngFor="let docType of documentTypes" [value]="docType.id">
                          {{docType.Name}}
                        </mat-option>
                      </mat-select>
    
                     
                    </mat-form-field>
                  </div>
                  <div class="col-md-3">
                    <mat-form-field>
                      <mat-label>Document Security</mat-label>
                      <mat-select formControlName="DocumentSecurityId">
                        <mat-option *ngFor="let security of documentSecurities" [value]="security.id">
                          {{security.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-3">
                    <mat-form-field>
                      <mat-label>Category</mat-label>
                      <mat-select formControlName="DocumentPhysicalLocationId">
                        <mat-option *ngFor="let location of documentPhysicalLocations" [value]="location.id">
                          {{location.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
    
              
            
                 
               
      
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          
        </div>
    
      
      
        <!-- <div class="row">
          <div class="col-md-12">
            <mat-accordion>
              <mat-expansion-panel class="section" >
                <mat-expansion-panel-header style="margin-bottom: 5px;">
                  <mat-panel-title style="padding:3rem 0;">
                    <mat-icon style="color: orange">supervisor_account</mat-icon> Classify
                  </mat-panel-title>
                  <mat-panel-description>
                   
                  </mat-panel-description>
                </mat-expansion-panel-header>
    
                <div class="row">
                  <div class="col-md-3">
                    <mat-form-field>
                      <mat-label>Location</mat-label>
                      <mat-select formControlName="EngagementLineOfBusinessId">
                        <mat-option *ngFor="let busiline of lineOfBusinesses" [value]="busiline.id">
                          {{busiline.Name}}
                        </mat-option>
                      </mat-select>
    
                     
                    </mat-form-field>
                  </div>
                  <div class="col-md-3">
                    <mat-form-field>
                      <mat-label>Shelve</mat-label>
                      <mat-select formControlName="EngagementTypeId">
                        <mat-option *ngFor="let engType of engagementTypes" [value]="engType.id">
                          {{engType.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-3">
                    <mat-form-field>
                      <mat-label>Shelve No</mat-label>
                      <mat-select formControlName="EngagementCategoryId">
                        <mat-option *ngFor="let engCat of engagementCategories" [value]="engCat.id">
                          {{engCat.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
    
                <div class="row">
                  <div class="col-md-3">
                    <mat-form-field>
                      <mat-label>Security Classification</mat-label>
                      <mat-select formControlName="EngagementGroupId">
                        <mat-option *ngFor="let food of foods" [value]="food.value">
                          {{food.viewValue}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-3">
                    <mat-form-field>
                      <mat-label>Other </mat-label>
                      <mat-select formControlName="EngagementDriverId">
                        <mat-option *ngFor="let engDriver of engagementDrivers" [value]="engDriver.id">
                          {{engDriver.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-3">
                    <mat-form-field>
                      <mat-label>other</mat-label>
                      <mat-select formControlName="EngagementCompanyId">
                        <mat-option *ngFor="let comp of companies" [value]="comp.id">
                          {{comp.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
            
            
                 
               
      
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          
        </div> -->
      
      
     
      
       
      
       
        
      
       </div>
      </form>
     </div>

     <!-- <a (click)="openFullscreen()" title="Full Screen"> Toggle fullscreen </a>
<div class="row"  #fullScreen>
   <div style="background-color: hotpink; color: black;width: 100%;">
       stuff
   </div>
</div> -->

    

     <div *ngIf="showList" >

      <div class=" the_table-grid">
             <div>
              <mat-checkbox class="example-margin" style=" margin-top: 0px;"  ></mat-checkbox> <span></span>
             </div>
             <div>
            <strong> Title</strong> 
           </div>
           <div>
            <strong>Type</strong>
             
          </div>
            
            <div>
              <strong>Filename</strong>
               
            </div>
            <div>
             <strong> Date</strong> 
            </div>
            <div style="text-align: right;">
             <strong>Size</strong> 
            </div>
            <div>
              
            </div>
      </div>
    
      <div *ngFor="let doc of myDocuments">
        <div class="the_table-grid" (click)="showdocument(doc)" style="cursor: pointer;">
          <div>
           <mat-checkbox class="example-margin" style=" margin-top: 0px;" (click)="$event.stopImmediatePropagation()"   ></mat-checkbox> <span><mat-icon style="color: orange;">supervisor_account</mat-icon></span>
          </div>
          <div>
            {{doc.DocumentTitle}}
        </div>
        <div>
          {{doc.DocumentType? doc.DocumentType.DocumentTypeName: ""}}
      </div>
         <div>
             {{doc.FileName}}
         </div>
         <div>
            {{doc.DocumentDate | date}}
         </div>
         <div style="text-align: right;">
         {{doc.FileSize}}
         </div>
         <div>
           <mat-icon style="color: orange"  matTooltip="View File">folder_open</mat-icon> <span style="padding-left: 4px;"><mat-icon style="color: green" matTooltip="Download File" (click)="downloadDoc(doc);$event.stopImmediatePropagation()">cloud_download</mat-icon></span>
         </div>
      </div>
          
      </div>
    
    </div>
    
    
      
      <div *ngIf="showDoc">

        <div class="stakeholder_search-reuslts" style="cursor:pointer; height: fit-content;" >
          <div class="name d-inline-block"><em class="ti-user ml-2"></em><h4 class="stakeholder_name d-inline-block"> {{selectedDocument.FileName}}</h4></div>
          <div class="phone_number d-inline-block" (click)="gobackToDocList()"><mat-icon>arrow_back</mat-icon></div>
          <button (click)="$event.stopImmediatePropagation()" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="downloadSelectedDoc()">
              <mat-icon>dialpad</mat-icon>
              <span>Download</span>
            </button>
            <button mat-menu-item (click)="gobackToDocList()">
              <mat-icon>arrow_back</mat-icon>
              <span>Back to List</span>
            </button>
            <button mat-menu-item disabled>
              <mat-icon>voicemail</mat-icon>
              <span>Classify</span>
            </button>
            <button mat-menu-item>
              <mat-icon>notifications_off</mat-icon>
              <span>Approve</span>
            </button>
            <button mat-menu-item>
              <mat-icon>notifications_off</mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
          
          <div class="search_info">
            <h5>
              <span class="title"> <em class="ti-calendar"></em>Owner</span>
              <span class="answer">679986</span>
            </h5>
            <h5>
              <span class="title"><em class="ti-flag-alt-2"></em>Date Modified </span>
              <span class="answer"> {{selectedDocument.DocumentDate | date}}</span>
            </h5>
            <h5>
              <span class="title"><em class="ti-target"></em> Type</span>
              <span class="answer">{{selectedDocument.DocumentType? selectedDocument.DocumentType.DocumentTypeName: ""}}</span>
            </h5>
            <h5>
              <span class="title"><em class="ti-email"></em>Accessors</span>
              <span class="answer"></span>
            </h5>
          </div>
          <mat-accordion>

                  

     

            <mat-expansion-panel class="section">
              <mat-expansion-panel-header style="margin-bottom: 5px;" (click)="$event.stopImmediatePropagation()">
                <mat-panel-title style="padding:3rem 0; color: green;" >
                  <span class=" mr-2"> <em class="ti-layers"></em></span> File Information
                </mat-panel-title>
                <mat-panel-description>
                 
                </mat-panel-description>
              </mat-expansion-panel-header>
          
             
              <div class=" input_card section">

                <form [formGroup]="documentForm"   >
                <div class="main_info">
              
                  <div class="panel_row">
                    <div style="width:95%;">
                      <div class="input_card" style="width:95%;">
                        <label for="">Title</label>
                        <input type="text" name="" id=""  class="description" 
                            placeholder="Enter description" formControlName="DocumentTitle" style="width:100%;"/>
                      </div>
                    </div>
                
                    <div style="width:95%;">
                      <div class="input_card" style="width: 95%;">
                        <label for="">File Name</label>
                        <input type="text" name="" id=""  class="description" 
                            placeholder="Ref No" formControlName="FileName" style="width:100%;"/>
                      </div>
                    </div>
                    
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="input_card">
                        <label for="">Description</label>
                        <textarea name="" id="" cols="130" rows="3" class="description" 
                            placeholder="Enter description" formControlName="DocumentDescription"></textarea>
                      </div>
                    </div>
                    
                  </div>
                
                  <div class="row panel_row">
                    <div style="width:95%;">
                      <div class="input_card" style="width:95%;">
                        <label for="">URL</label>
                        <textarea name="" id="" rows="3" class="description" 
                            placeholder="Enter description" formControlName="DocumentURL" (mouseleave)="doesFileExistwithURL()"></textarea>
                      </div>
                      <div class="alert alert-danger" *ngIf="!fileExist">
                           {{fileExistMsg}}
                      </div>
                    </div>
                
                    <div style="width:95%;">
                      <div class="input_card" style="width: 95%;">
                        <label for="">Other</label>
                        <textarea name="" id="" rows="3" class="description" 
                            placeholder="Enter " ></textarea>
                      </div>
                    </div>
                    
                  </div>
          
          
                  <div class="row">
                    <div class="col-md-12">
                      <mat-accordion>
                        <mat-expansion-panel class="section" >
                          <mat-expansion-panel-header style="margin-bottom: 5px;">
                            <mat-panel-title style="padding:3rem 0;">
                              <mat-icon style="color: orange">supervisor_account</mat-icon> Categorise
                            </mat-panel-title>
                            <mat-panel-description>
                             
                            </mat-panel-description>
                          </mat-expansion-panel-header>
              
                          <div class="row">
                            <div class="col-md-3">
                              <mat-form-field>
                                <mat-label>Document Type</mat-label>
                                <mat-select formControlName="DocumentTypeId">
                                  <mat-option *ngFor="let docType of documentTypes" [value]="docType.id">
                                    {{docType.Name}}
                                  </mat-option>
                                </mat-select>
              
                               
                              </mat-form-field>
                            </div>
                            <div class="col-md-3">
                              <mat-form-field>
                                <mat-label>Document Security</mat-label>
                                <mat-select formControlName="DocumentSecurityId">
                                  <mat-option *ngFor="let security of documentSecurities" [value]="security.id">
                                    {{security.Name}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="col-md-3">
                              <mat-form-field>
                                <mat-label>Category</mat-label>
                                <mat-select formControlName="DocumentPhysicalLocationId">
                                  <mat-option *ngFor="let location of documentPhysicalLocations" [value]="location.id">
                                    {{location.Name}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
              
                        
                      
                           
                         
                
                        </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                    
                  </div>
              
                
                
                  <!-- <div class="row">
                    <div class="col-md-12">
                      <mat-accordion>
                        <mat-expansion-panel class="section" >
                          <mat-expansion-panel-header style="margin-bottom: 5px;">
                            <mat-panel-title style="padding:3rem 0;">
                              <mat-icon style="color: orange">supervisor_account</mat-icon> Classify
                            </mat-panel-title>
                            <mat-panel-description>
                             
                            </mat-panel-description>
                          </mat-expansion-panel-header>
              
                          <div class="row">
                            <div class="col-md-3">
                              <mat-form-field>
                                <mat-label>Location</mat-label>
                                <mat-select formControlName="EngagementLineOfBusinessId">
                                  <mat-option *ngFor="let busiline of lineOfBusinesses" [value]="busiline.id">
                                    {{busiline.Name}}
                                  </mat-option>
                                </mat-select>
              
                               
                              </mat-form-field>
                            </div>
                            <div class="col-md-3">
                              <mat-form-field>
                                <mat-label>Shelve</mat-label>
                                <mat-select formControlName="EngagementTypeId">
                                  <mat-option *ngFor="let engType of engagementTypes" [value]="engType.id">
                                    {{engType.Name}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="col-md-3">
                              <mat-form-field>
                                <mat-label>Shelve No</mat-label>
                                <mat-select formControlName="EngagementCategoryId">
                                  <mat-option *ngFor="let engCat of engagementCategories" [value]="engCat.id">
                                    {{engCat.Name}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
              
                          <div class="row">
                            <div class="col-md-3">
                              <mat-form-field>
                                <mat-label>Security Classification</mat-label>
                                <mat-select formControlName="EngagementGroupId">
                                  <mat-option *ngFor="let food of foods" [value]="food.value">
                                    {{food.viewValue}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="col-md-3">
                              <mat-form-field>
                                <mat-label>Other </mat-label>
                                <mat-select formControlName="EngagementDriverId">
                                  <mat-option *ngFor="let engDriver of engagementDrivers" [value]="engDriver.id">
                                    {{engDriver.Name}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                            <div class="col-md-3">
                              <mat-form-field>
                                <mat-label>other</mat-label>
                                <mat-select formControlName="EngagementCompanyId">
                                  <mat-option *ngFor="let comp of companies" [value]="comp.id">
                                    {{comp.Name}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                      
                      
                           
                         
                
                        </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                    
                  </div> -->
                
                
               
                
                 
                
                 
                  
                
                 </div>
                </form>
               </div>
      
            </mat-expansion-panel>
      
           
          </mat-accordion>

        <!-- Panel with Go Back Button here -->
           <div style="height: fit-content;">
            <div *ngIf="docType === 'Image'">
              <angular-image-viewer  [src]="images" [(config)]="config" [(index)]="imageIndexOne"
              [screenHeightOccupied]='0'  (customImageEvent)="handleEvent($event)"   >
            </angular-image-viewer>
             </div>
           
             <div *ngIf="docType === 'pdf' || docType === 'mammoth'">
              <ngx-doc-viewer 
              queryParams="hl=Nl"
              [url]="selectedDocument.FileUploadPath"
              [viewer]="docType"
              style="width:100%;height:80vh;min-height: 800px;"
               ></ngx-doc-viewer>
             </div>

             <div *ngIf="docType === 'Excel'" class="table-responsive" #fullScreen>
              <table id="TheTable" class="table table-bordered table-hover">
                <thead #header class="thead-dark">
                  <tr>
                    <th *ngFor="let headValue of headData" id="mainTableHead">
                      {{headValue}}
                    </th>
                  </tr>
                </thead>
                <tbody #container>
                  <tr *ngFor="let row of data">
                    <td *ngFor="let val of headData; let em=index">
                      {{row[i] || ' '}}
                    </td>
                  </tr>
                </tbody>
              </table>
             </div>
    
           </div>

        </div>
    
        
    </div>
  </div>


 





 


  

 


  
  
 

